import { Box } from "@mui/material";
import React from "react";
import { normalizeMultilineText } from "../../Utils/helper";

const MultilineText = ({ value, sx = {} }) => {
  const normalized = normalizeMultilineText(value);
  if (!normalized) {
    return null;
  }

  const lines = normalized.split("\n");

  return (
    <Box
      component="div"
      sx={{
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        fontSize: "1rem",
        fontWeight: 400,
        ...sx,
      }}
    >
      {lines.map((line, index) => (
        <React.Fragment key={`line-${index}`}>
          {line}
          {index < lines.length - 1 ? <br /> : null}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default MultilineText;
